import { useEffect } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { ImproveSvg, SaveSvg, HeavyDutySvg } from '@/components/UI/svg/delta2max';

const SCROLL_WIDTH = 14;

export default function D() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2max.detail');

    useEffect(() => {
        let pageW = window.innerWidth - SCROLL_WIDTH;
        pageW = pageW > 2560 ? 2560 : pageW;

        AniContainer.create({
            asyncFromTo: [['.d2x-detail-D .video-box', { y: -(pageW * 0.07769) }, { y: 0 }, 1]],
            asyncTimeLine: [0],
            triggerElement: '.d2x-detail-D .video-box',
            triggerHook: 1,
            offset: 0,
            duration: '184%',
        });
        AniContainer.create({
            asyncFromTo: [
                ['.d2x-detail-D .point1', { y: 50 }, { y: 0 }, 1],
                ['.d2x-detail-D .point2', { y: 100 }, { y: 0 }, 2],
                ['.d2x-detail-D .point3', { y: 150 }, { y: 0 }, 3],
            ],
            asyncTimeLine: [0, 0, 0],
            triggerElement: '.d2x-detail-D .point-box',
            triggerHook: 1,
            offset: '5%',
            duration: '10%',
        });
    }, []);

    return (
        <div
            className={`d2x-detail-D ${css.d2xDetailD} GtmModuleData-section`}
            id="d2x-detail-D"
            data-section-id={'d2x-detail-D'}
            data-section-title={t('sec4_title')}
        >
            <div className="white-box">
                <div className="text-box">
                    <div className="slogan">{t('sec4_slogan')}</div>
                    <div className="title">{t('sec4_title')}</div>
                    <div className="desc">{t('sec4_desc')}</div>
                </div>
            </div>
            <div className="ani-box">
                <div className="video-box">
                    <div className="video">
                        <NextImage
                            webpSrc={require('@publicLocal/delta2max/teaser/pc/eu/zc.webp')}
                            src={require('@publicLocal/delta2max/teaser/pc/eu/zc.jpg')}
                            alt={t('sec4_title')}
                            aria-label={t('sec4_title')}
                        />
                    </div>
                </div>
            </div>
            <div className="white-point">
                <div className="point-box">
                    <div className="point1">
                        <div className="icon">
                            <ImproveSvg />
                        </div>
                        <div className="text">{t('sec4_point1')}</div>
                    </div>
                    <div className="point2">
                        <div className="icon">
                            <SaveSvg />
                        </div>
                        <div className="text">{t('sec4_point2')}</div>
                    </div>
                    <div className="point3">
                        <div className="icon">
                            <HeavyDutySvg />
                        </div>
                        <div className="text">{t('sec4_point3')}</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
